"use client";
import React from "react";
import { motion } from "framer-motion";
import { Sun, Wallet, Cpu, Settings } from "lucide-react";
import { impactData } from "../data/impactData";

const Impact = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: false }}
      className="flex flex-col bg-quad lg:justify-evenly lg:h-[100vh] py-[4rem] px-[1.5rem] sm:px-[3rem] lg:px-[6rem]"
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: false }}
        className="flex flex-col gap-3 mb-4"
      >
        <div className="text-pri text-desc-size2 flex items-center gap-2">
          <Sun size={20} />
          <span>{impactData.title.mainTitle}</span>
        </div>
        <div className="text-text1 text-title-size3 lg:text-title-size2 md:w-[60vw] leading-[1]">
          {impactData.title.heading}
        </div>
      </motion.div>

      <div className="flex flex-col gap-16 lg:flex-row lg:gap-[5vw] mt-8">
        {impactData.cards.map((card, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: index * 0.2 }}
            viewport={{ once: false }}
            className="flex flex-col items-start gap-3 lg:w-[30vw] max-w-[600px]"
          >
            <div className="flex w-12 h-12 rounded-sm bg-pri items-center justify-center">
              {card.icon}
            </div>
            <div className="text-color1 text-desc-size1 font-weight1">
              {card.title}
            </div>
            <div className="text-color3 text-desc-size2">
              {card.description}
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Impact;
